import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

function usePrevious(value) {
  const ref = useRef<typeof value>();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

function getFirstTwoParts(pathname) {
  const parts = pathname.split('/');
  return parts.slice(0, 2).join('/');
}

export function ScrollToTop() {
  const { pathname } = useLocation();
  const prevPathname = usePrevious(pathname);

  useEffect(() => {
    if (pathname && prevPathname && getFirstTwoParts(pathname) !== getFirstTwoParts(prevPathname)) {
      window.scrollTo(0, 0);

      const content = document.getElementById('content-wrapper');
      if (content != null) {
        content.scrollTo(0, 0);
      }
    }
  }, [pathname, prevPathname]);

  return null;
}
